import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from './store';
import { AppFeatures } from '@urbanx/agx.agencies.client';
import { FormState } from '@urbanx/agx.campaigns.client';

interface AgentInfoState {
  agentId: string | null;
  agencyId: string | null;
  featureToggles: { [key in FormState]: AppFeatures } | null;
}

const initialState = {
  agentId: null,
  agencyId: null,
  featureToggles: null,
} satisfies AgentInfoState as AgentInfoState;

const slice = createSlice({
  name: 'agentInfo',
  initialState: initialState,
  reducers: {
    agentUpdate: (
      state,
      action: PayloadAction<{
        agent: string | null;
        agency: string | null;
      }>
    ) => {
      return {
        ...state,
        agentId: action.payload.agent,
        agencyId: action.payload.agency,
      };
    },
    featureTogglesLoaded: (
      state,
      action: PayloadAction<
        | {
            [key in FormState]: AppFeatures;
          }
        | null
      >
    ) => {
      return {
        ...state,
        featureToggles: action.payload,
      };
    },
  },
});

export default slice.reducer;

// Actions
const { agentUpdate, featureTogglesLoaded } = slice.actions;

export const updateAgent =
  (agent: { agent: string | null; agency: string | null }) =>
  async (dispatch: AppDispatch) => {
    dispatch(agentUpdate(agent));
  };

export const updateFeatureToggles =
  (
    featureToggles: {
      [key: string]: AppFeatures;
    } | null
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch(
      featureTogglesLoaded(
        featureToggles as { [key in FormState]: AppFeatures } | null
      )
    );
  };
